export default __webpack_public_path__ + "static/media/ic_wglmr_24.42b84f89.svg";